import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import { RightNavItems } from "./right-nav-items";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Link from "next/link";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";
import {
  selectNotificationsUnreadCount,
  selectIsMuted,
} from "@/store/slices/notifications/notificationsSlice";
import { useEffect, useState } from "react";
import * as styles from "./notification-menu/style.module.scss";
import TruncateTooltip, {
  TooltipComponent,
} from "@/components/truncate-with-tooltip";
import storage from "@/services/storage";
import { navigateToLegacyCompanySelector, checkSmarthubUser } from "@/services/generic.methods";
import { selectRoles } from "@/store/slices/roles/rolesSlice";

const DesktopMenu = ({ handleMenuOpen, displayName }) => {
  let { pathname } = useRouter();
  const unreadCount = useSelector(selectNotificationsUnreadCount);
  const isMuted = useSelector(selectIsMuted);
  const [animateBell, setAnimateBell] = useState(null);
  const profile = JSON.parse(storage.getItem("Profile"));
  const { roles } = useSelector(selectRoles);
  const canViewSettings = roles?.settings?.view !== false;
  
  const displayedCount = isMuted ? 0 : unreadCount;

  useEffect(() => {
    if (displayedCount) {
      setTimeout(() => {
        setAnimateBell(styles.animateBell);
        setTimeout(() => {
          setAnimateBell(null);
        }, 600);
      }, 400);
    }
  }, [displayedCount]);

  return (
    //  on desktop screen right hand icons
    <Box sx={{ display: { xs: "none", sm: "flex" }, alignItems: "center" }}>
      {RightNavItems.filter(item =>   (item.name !== "switchTo" || !checkSmarthubUser()) &&
    (item.name !== "settings" || canViewSettings)).map((item) => (
        <TooltipComponent
          key={item?.id}
          showTooltip={item?.showTooltip}
          text={item?.title}
        >
          <IconButton
            key={item?.id}
            size="large"
            aria-label={item?.name}
            color="inherit"
            sx={{ color: "var(--palette-header_text) !important" }}
            name={item?.name}
            className={`menu-icon-btn ${
              item?.name == "settings" && pathname?.includes("/crm/settings")
                ? "active"
                : ""
            } ${item?.name === "settings" ? "settings-icon-tour" : ""}`}
            aria-controls={item?.name}
            aria-haspopup={item?.haspopup}
            onClick={(e) => {
              if (item?.clearSessionBeforeNavigate) {
                e.preventDefault();
                navigateToLegacyCompanySelector();
                return;
              }
              if (item?.haspopup) {
                handleMenuOpen(e);
              }
            }}
            disableRipple={true}
          >
            {item?.clearSessionBeforeNavigate ? (
              <span
                style={{
                  color: "var(--palette-header_text)",
                  cursor: "pointer",
                }}
              >
                {item?.icon}
              </span>
            ) : item?.link ? (
              <Link
                href={item?.link}
                target={item.redirect ? "_blank" : "_self"}
              >
                <span
                  style={{
                    color: "var(--palette-header_text)",
                  }}
                >
                  {item?.icon}
                </span>
              </Link>
            ) : item.name === "notifications" ? (
              item?.icon(displayedCount, animateBell)
            ) : item.name === "profile" ? (
              item?.icon(profile)
            ) : (
              item?.icon
            )}
            {item?.name === "profile" && (
              <Typography
                sx={{
                  ml: "5px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                }}
                component="span"
                variant="body2"
                color="custom.header_text"
              >
                <Box
                  className="d-flex align-items-start"
                  sx={{ flexDirection: "column" }}
                >
                  <TruncateTooltip
                    text={displayName}
                    limit={12}
                    sx={{
                      fontWeight: 500,
                      fontSize: "1rem",
                      lineHeight: "normal",
                      color: "custom.header_text",
                    }}
                  />
                  <TruncateTooltip
                    text={profile?.CompanyName}
                    limit={12}
                    sx={{
                      fontSize: "0.8rem",
                      lineHeight: "normal",
                      color: "custom.header_text",
                    }}
                  />
                </Box>
                <ExpandMoreIcon fontSize="small" />
              </Typography>
            )}
          </IconButton>
        </TooltipComponent>
      ))}
    </Box>
  );
};

export default DesktopMenu;
